import React from "react"
import propTypes from "prop-types"
import { Link } from "gatsby"
import { css } from "@emotion/react"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

import { ln2Span } from "../components/util-functions"
import { fontSize, globalColors } from "../components/css-functions"

import SvgTabButton from "../assets/svg/tab_button.svg"

const SubNavigation = ({
  navItems,
  pagePath,
  urlParam,
}) => {
  if (typeof urlParam === 'undefined') {
    urlParam = navItems[0].label
  }

  const bp = useBreakpoint()

  const style = {
    list: css`
      margin: 0 auto;
      max-width: 640px;
      display: flex;
      justify-content: space-evenly;
    `,
    listItem: css`
    `,
    link: css`
      width: ${ bp.isTablet ? '116px' : '72px'};
      height: ${ bp.isTablet ? '72px' : '45px'};
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 0.4s ease;
      position: relative;
      ${bp.isTablet ? fontSize(16) : fontSize(12)}
      font-weight: 200;
      text-align: center;
      color: ${globalColors.black};
      outline: none;
      &:visited {
        color: ${ globalColors.black }
      }
      &.active {
        pointer-events: none;
      }
    `,
    svgWrapper: css`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0.6;
      z-index: -1;
      &.active {
        opacity: 1;
      }
    `,
  }

  return (
    <ul css={ style.list }>
      { navItems.map(item => (
        <li
          key={ item.label }
          css={ style.listItem }
        >
          <Link
            to={ `${ pagePath }?t=${ item.label }` }
            css={ style.link }
            className={ urlParam === item.label ? 'active' : '' }
          >
            { ln2Span(item.name) }
            <div
              css={ style.svgWrapper }
              className={ urlParam === item.label ? 'active' : '' }
            >
              <SvgTabButton />
            </div>
          </Link>
        </li>
      )) }
    </ul>
  )
}

SubNavigation.propTypes = {
  navItems: propTypes.array,
  pagePath: propTypes.string,
  urlParam: propTypes.string,
}

export default SubNavigation